import {importOrder} from "./importOrder";

const orders = {
	"bulkUpdate_BtnBulkUpdate": "Bulk Update",
	"bulkUpdate_BtnClearUpload": "Clear Upload",
	"bulkUpdate_col_AdditionalReference": "Additional Reference",
	"bulkUpdate_col_AllocatedPercentage": "Allocated Percentage",
	"bulkUpdate_col_ArticleNo": "Article No.",
	"bulkUpdate_col_Buyer": "Buyer",
	"bulkUpdate_col_BuyerPreferredEta": "Buyer Preferred ETA",
	"bulkUpdate_col_ClientAccount": "Client Account",
	"bulkUpdate_col_CommodityDescription": "Commodity Description",
	"bulkUpdate_col_DcPercentage": "DC Percentage",
	"bulkUpdate_col_ImportOutstandingAmount": "Import Outstanding Amount",
	"bulkUpdate_col_OnAdDate": "On Ad Date",
	"bulkUpdate_col_OrderNo": "Order No.",
	"bulkUpdate_col_OrderPlacement": "Order Placement",
	"bulkUpdate_col_PaymentInfo": "Payment Info",
	"bulkUpdate_col_ProductCategory": "Product Category",
	"bulkUpdate_col_SecondaryOrderNo": "Secondary Order No.",
	"bulkUpdate_col_Skus": "SKUs",
	"bulkUpdate_col_Valid": "Valid",
	"bulkUpdate_CsvParseError": "Error parsing CSV file",
	"bulkUpdate_DropzoneText": "Drag and drop a CSV file here, or click to select a file to upload",
	"bulkUpdate_FieldCanBeUpdated": "This field can be updated",
	"bulkUpdate_Help_BtnClose": "Close",
	"bulkUpdate_Help_BtnHelp": "Help",
	"bulkUpdate_Help_FieldsLabel": "The following fields are available for bulk update:",
	"bulkUpdate_Help_Step1": "Export a Briscoes Orders report from the Reports page as a CSV file.",
	"bulkUpdate_Help_Step2": "Update the report with any changes, and save it.",
	"bulkUpdate_Help_Step3": "Upload the updated file to this page.",
	"bulkUpdate_Help_Step4": "Review the changes, and click on the Bulk Update button to submit them.",
	"bulkUpdate_Help_Title": "Bulk Update Help",
	"bulkUpdate_InvalidDataTitle": "Invalid Bulk Update Data",
	"bulkUpdate_InvalidMultipleText": "The following orders contain invalid data, and will not be updated:",
	"bulkUpdate_InvalidSingle": "The order {orderNumber} contains invalid data and will not be updated.",
	"bulkUpdate_NotAvailable": "Bulk update not available for this organisation.",
	"bulkUpdate_NoValidUpdates": "No valid updates found in the uploaded file.",
	"bulkUpdate_SelectOrganisation": "Please select an organisation.",
	"bulkUpdate_Title": "Bulk Update",
	"bulkUpdate_UpdateError": "An error has occurred while processing the bulk update",
	"bulkUpdate_UpdateSuccess": "Bulk Update Successful",

	...importOrder
};

export { orders };
